<template>
    <li class="nav-item dropdown pe-2 d-flex align-items-center">
        <a href="javascript:;" class="nav-link text-white p-0 position-relative" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-bell cursor-pointer" aria-hidden="true"></i>
            <span class="icon_noti">{{ ContadorNotificaciones }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end px-2 py-3 me-sm-n4" style="max-height:400px;overflow-y:auto" aria-labelledby="dropdownMenuButton">
            <li v-for="(item,index) in ListaNotificaciones" :key="index" class="mb-2">
                <a @click="VerNotificacion(item);RedireccionNotificacion(item.TipoNotificacion,item)" class="dropdown-item border-radius-md" href="javascript:;">
                    <div class="d-flex py-1">
                        <!-- <div class="my-auto">
                            <img src="images/team-2.jpg" class="avatar avatar-sm  me-3 ">
                        </div> -->
                        <div class="d-flex flex-column justify-content-center">
                            <h6 class="text-sm font-weight-normal mb-1">
                            <span class="font-weight-bold">{{ item.Descripcion }}</span>
                            </h6>
                            <p class="text-xs text-secondary mb-0">
                            <i class="fa fa-clock me-1" aria-hidden="true"></i>
                            {{ item.Tiempo }}
                            </p>
                        </div>
                    </div>
                </a>
            </li>
            <li v-show="ListaNotificaciones.length==0">
                <h6>Sin Notificaciones</h6>
            </li>
        </ul>
    </li>
</template>

<script>
export default {
    name:'Notificacion',
    data() {
        return {
            ContadorNotificaciones:0,
            ListaNotificaciones:[],
            IdUsuario:0,
            ContadorRecordatorios:0
        }
    },
    methods: {
        async ListarNotificaciones(){
            await this.$http.get('notificaciones',{
                params:{
                    ContadorRecordatorios:this.ContadorRecordatorios
                }
            }
            ).then((res)=>{
                this.ListaNotificaciones=res.data.data;
                this.ContadorNotificaciones=res.data.count;
                this.ContadorRecordatorios++;
            })
        },
        RedireccionNotificacion(TipoNotificacion,item){
            switch (TipoNotificacion) {
                case 1:
                    this.$router.push({name:'prospectos',params:{}});
                    break;
                case 2:
                    this.$router.push({name:'agenda',params:{objEnviado:item.Cliente}});
                    break;
                case 3:
                    this.$router.push({name:'cotizacion',params:{objEnviado:item.Cliente}});
                    break;
                case 4:
                    this.$router.push({name:'',params:{}});
                    break;
                case 5:
                    this.$router.push({name:'cuentaporcobrar',params:{}});
                    break;
                case 6:
                    this.$router.push({name:'cuentaporpagar',params:{}});
                    break;
                case 7:
                    this.$router.push({name:'Requisicion',params:{}});
                    break;
                case 8:
                    this.$router.push({name:'OrdenCompra',params:{}});
                    break;
                case 9:
                    this.$router.push({name:'solicitudalmacen',params:{}});
                    break;
            }
        },
        async VerNotificacion(item){
            await this.$http.post('notificaciones/'+item.IdNotificacion,item
            ).then((res)=>{
                this.ListarNotificaciones();
            })
        }
    },
    created() {
        //this.ListarNotificaciones();
    },
}
</script>

<style>
    .icon_noti {
        position: absolute;
        top: -0.4rem;
        left: 0.7rem;
        width: 1rem;
        height: 1rem;
        text-align: center;
        color: white;
        font-size: 0.7rem;
        background-color: red;
        border-radius: 50%;
    }
</style>